import styled, { css } from 'styled-components';
import { ICON_SIZES } from '../../icon';
import { pxToRem } from '../../../design-tokens/style-utilities';
const svgIconStyles = ({ theme, $size, }) => {
    const size = typeof $size === 'string' ? { initial: $size } : $size;
    const breakpoints = Object.keys(size).filter((key) => key !== 'initial');
    return css `
		display: inline-block;
		height: ${pxToRem(ICON_SIZES[size.initial])};
		width: ${pxToRem(ICON_SIZES[size.initial])};
		fill: currentcolor;

		${breakpoints.map((breakpoint) => {
        return css `
				@media (min-width: ${pxToRem(theme.viewportBreakpoint[breakpoint])}) {
					height: ${pxToRem(ICON_SIZES[size[breakpoint]])};
					width: ${pxToRem(ICON_SIZES[size[breakpoint]])};
				}
			`;
    })}
	`;
};
export const StyledSvgIcon = styled.svg `
	${svgIconStyles}
`;
